import { Navigate } from 'react-router-dom'
// project imports
import PublicLayout from '../layout/public-layout';
import PageNotFound from '../pages/public/404/404';
import Invite from '../pages/public/Invite/Invite';
// ==============================|| MAIN ROUTING ||============================== //

const PublicRoutes = {
  path: '/public',
  element: <PublicLayout />,
  children: [
    {
      path: 'invite/:activationToken',
      element: <Invite />
    },
    {
      path: '404',
      element: <PageNotFound />
    },
    {
      path: "*",
      element: <Navigate to="/public/404" replace />
    }
  ]
};

export default PublicRoutes;
